import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { EndPoints } from "../../../../endPoints/endPoints";
import {
  IContractWork,
  IContractWorkInfo,
  IContractWorkNew,
} from "./IContractWork";

export const contracWorkstApi = createApi({
  reducerPath: "contract-works",
  baseQuery: fetchBaseQuery({
    baseUrl: EndPoints.CONTRACT_WORKS,
  }),
  tagTypes: ["contract-works", "contract-task"],
  endpoints: (builder) => ({
    /*     getFilteredContracts: builder.query<any, string>({
      query(searchParams) {
        return {
          url: `/pagination?${searchParams}`,
        };
      },
      providesTags: ["contracts"],
    }), */
    getAllContractWorks: builder.query<IContractWorkInfo[], number>({
      query(contract_id) {
        return {
          url: `/contract/${contract_id}`,
          method: "GET",
          credentials: "include",
        };
      },
      providesTags: ["contract-works"],
    }),
    addContractWork: builder.mutation<any, IContractWorkNew>({
      query(data) {
        const { cost, ...rest } = data;
        const costInCents = Math.floor(cost * 100);

        return {
          url: "",
          method: "POST",
          credentials: "include",
          body: { cost: costInCents, ...rest },
        };
      },
      invalidatesTags: ["contract-works"],
    }),
    getContractWork: builder.query<IContractWork, number>({
      query(id) {
        return {
          url: `/contract/${id}`,
          method: "GET",
          credentials: "include",
        };
      },
      providesTags: ["contract-task"],
    }),
    editContractWork: builder.mutation<IContractWork, IContractWork>({
      query(data) {
        const { id, cost, ...rest } = data;
        const costInCents = Math.floor(cost * 100);
        return {
          url: `/${id}`,
          method: "PUT",
          credentials: "include",
          body: { cost: costInCents, ...rest },
        };
      },
      invalidatesTags: ["contract-task", "contract-works"],
    }),
    deleteContractWork: builder.mutation<string, number>({
      query(id) {
        return {
          url: `/${id}`,
          method: "DELETE",
          credentials: "include",
        };
      },
      invalidatesTags: ["contract-works"],
    }),
  }),
});

export const {
  useAddContractWorkMutation,
  useDeleteContractWorkMutation,
  useEditContractWorkMutation,
  useGetAllContractWorksQuery,
  useGetContractWorkQuery,
} = contracWorkstApi;
